export const API_URL = window.configuration.apiUrl;
export const WS_API_BASE_URL = API_URL.replace(/^http(s)?:\/\/?/i, 'ws$1://');
export const WS_API_BASE_URL_MOCK = 'ws://127.0.0.1:8085';
